<template>
  <a-modal
    v-model="visible"
    :after-close="afterClose"
    :destroy-on-close="true"
    :footer="null"
    :title="item.title"
    :width="1080"
  >
    <a-space size="large" style="margin-bottom: 24px">
      <datetime-range
        :allow-clear="false"
        :default-value="defaultValue"
        @ok="
          v => {
            datetimeRange = v
          }
        "
      ></datetime-range>
      <a-checkbox v-model="compareYesterday">
        <question-icon title="环比" description="昨天同时段"></question-icon>
      </a-checkbox>
      <a-checkbox v-model="compareLastWeek">
        <question-icon title="同比" description="上周同时段"></question-icon>
      </a-checkbox>
    </a-space>

    <multi-line-chart
      :compare-last-week="compareLastWeek"
      :compare-yesterday="compareYesterday"
      :datetime-range="datetimeRange"
      :history-func="historyFunc"
      :item="item"
      :source-id="sourceId"
    ></multi-line-chart>
  </a-modal>
</template>

<script>
import moment from 'moment'
import DatetimeRange from '@/components/DatetimeRange'
import QuestionIcon from '@/components/icon/QuestionIcon'
import MultiLineChart from './modules/MultiLineChart'

export default {
  name: 'MultiLineChartModal',
  components: {
    DatetimeRange,
    MultiLineChart,
    QuestionIcon
  },
  props: {
    defaultValue: {
      type: Array,
      default: () => {
        return [moment().subtract(1, 'hour'), moment()]
      }
    },
    historyFunc: {
      type: Function,
      required: true
    },
    sourceId: {
      type: String
    }
  },
  data () {
    return {
      item: {},
      visible: false,
      datetimeRange: this.defaultValue || [],
      compareYesterday: false,
      compareLastWeek: false
    }
  },
  methods: {
    show (item) {
      this.item = item
      this.visible = true
    },
    afterClose () {
      this.compareYesterday = false
      this.compareLastWeek = false
    }
  }
}
</script>
